module.exports = __webpack_public_path__ + "static/media/sensable_75.c15cea6a.png";